import {Environment, getCurrentEnvironment} from "../utilities/environment"

type BankAndOrgId = {
	bankId: string
	orgId: string
}

// Orgs

// SANDBOX
const eladSandboxOrgId = "2673"
const yaelSandboxOrgId = "901"
const shahafSandboxOrgId = "87"
const testingSandboxOrgId = "15"
const unitFinanceIncOrgId = "1"

const seisSandboxOrgId = "113"
const relaySandboxOrgId = "1221"
const threadOrgSandboxOrgId = "6770"
const baselaneuatOrgSandboxOrgId = "563"
const everySandboxOrgId = "645"

// PRODUCTION
const seisProductionOrgId = "27"
const relayProductionOrgId = "444"

// Banks

// Local
const eladLocalBankAndOrgId: BankAndOrgId = {bankId: "1", orgId: "34"}

// SANDBOX
const eladSandboxBankAndOrgId: BankAndOrgId = {bankId: "26", orgId: "2673"}
const eladSandboxBankAndOrgId2: BankAndOrgId = {bankId: "26", orgId: "1679"}

// PRODUCTION
const threadProductionBankAndOrgId: BankAndOrgId = {bankId: "5", orgId: "1244"}

// This is temporary setup, in the future it will be moved to more structural solution for org policies
const allowedOrgIds = new Map<Environment, Set<string>>([
	[
		Environment.Sandbox,
		new Set<string>([
			eladSandboxOrgId,
			yaelSandboxOrgId,
			shahafSandboxOrgId,
			seisSandboxOrgId,
			relaySandboxOrgId,
			testingSandboxOrgId,
			unitFinanceIncOrgId,
			threadOrgSandboxOrgId,
			baselaneuatOrgSandboxOrgId,
			everySandboxOrgId,
		]),
	],
	[Environment.Production, new Set<string>([seisProductionOrgId, relayProductionOrgId])],
])

const allowedBankIds = new Map<Environment, Set<string>>([
	[Environment.Local, new Set<string>([getKey(eladLocalBankAndOrgId)])],
	[Environment.Sandbox, new Set<string>([getKey(eladSandboxBankAndOrgId), getKey(eladSandboxBankAndOrgId2)])],
	[Environment.Production, new Set<string>([getKey(threadProductionBankAndOrgId)])],
])

export function isOrgManageResubmitApplication(orgId: string): boolean {
	const currentEnv = getCurrentEnvironment()
	const alwaysAllowedEnv = currentEnv == Environment.Local

	const allowedIds = allowedOrgIds.get(getCurrentEnvironment()) ?? new Set<string>()

	if (orgId) {
		return alwaysAllowedEnv || allowedIds.has(orgId)
	}

	return alwaysAllowedEnv
}

export function isBankManageResubmitApplication(bankId: string, relatedOrgId?: string): boolean {
	const currentEnv = getCurrentEnvironment()
	const alwaysAllowedEnv = currentEnv == Environment.Local

	const allowedIds = allowedBankIds.get(currentEnv) ?? new Set<string>()

	if (bankId && relatedOrgId) {
		const key = getKey({bankId, orgId: relatedOrgId})
		return alwaysAllowedEnv || allowedIds.has(key)
	}

	return alwaysAllowedEnv
}

function getKey(bankAndOrg: BankAndOrgId) {
	return `${bankAndOrg.bankId}:${bankAndOrg.orgId}`
}
